<template>
  <pt-live-list-form class="pt-live-list-form__page" :isEdit="is_edit" :id="id"></pt-live-list-form>
</template>

<script>
import PtLiveListForm from 'cps/famous-doctor-hall/pt-live-list/pt-live-list-form/withData'
export default {
  name: 'pt-live-list-form__view',
  components: {
    'pt-live-list-form': PtLiveListForm
  },
  props: {
    isEdit: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
